import React from 'react';
import { LiliButton } from '@lili/lili-frontend-common';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-white-icon.svg';
import { SearchBar } from './TableSearchBar';

interface IProductsHeaderProps {
  title: string;
  addButtonTitle: string;
  addButtonDisabled: boolean;
  searchPlaceholder: string;
  onSearch: (searchText: string) => void;
  onAddNewClick: () => void;
  totalProductsCount: number;
}

export const ItemsTableHeader = ({
  title,
  addButtonTitle,
  searchPlaceholder,
  onSearch,
  onAddNewClick,
  addButtonDisabled,
  totalProductsCount,
}: IProductsHeaderProps) => (
  <div className='mt-[20px]'>
    <p className='mb-[30px]'>
      <span className='font-metricRMedium text-[32px] text-bw08'>{title}</span>
      <span className='font-metricR text-[32px] text-bw05'>
        {' '}
        {totalProductsCount > 0 ? `(${totalProductsCount})` : ''}
      </span>
    </p>
    <div className='flex justify-between mb-[16px] items-center'>
      <SearchBar onSearch={onSearch} searchPlaceholder={searchPlaceholder} />
      <LiliButton
        id='planPickerTab'
        title={addButtonTitle}
        className='w-[160px] text-[14px] h-[40px]'
        disabled={addButtonDisabled}
        onClick={onAddNewClick}
        icon={<PlusIcon />}
      />
    </div>
  </div>
);
